/* MIKOO: right-to-left fixes for Dawn's sliders. Loaded before global.js, so it can adjust the
   slider classes as Dawn registers them.
   In RTL browsers scrollLeft runs from 0 to negative values, and item offsetLeft does the same, so
   most of Dawn's slider maths already works. Two parts do not:
   1. the page count (used by the "1/5" counter on product galleries) divides by a negative step;
   2. "previous" on the first slide wraps to a positive position, which RTL clamps back to the start. */
(function () {
  if (document.documentElement.getAttribute('dir') !== 'rtl') return;

  function patchPages(proto) {
    proto.initPages = function () {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (element) {
        return element.clientWidth > 0;
      });
      if (this.sliderItemsToShow.length < 2) return;
      var first = this.sliderItemsToShow[0];
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - first.offsetLeft;
      var step = Math.abs(this.sliderItemOffset);
      var startGap = Math.max(0, this.slider.clientWidth - (first.offsetLeft + first.clientWidth));
      this.slidesPerPage = Math.max(1, Math.floor((this.slider.clientWidth - startGap) / step));
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    };
  }

  function patchWrap(proto) {
    var setSlidePosition = proto.setSlidePosition;
    proto.setSlidePosition = function (position) {
      /* a positive target only comes from "previous" on the first slide: go to the last slide instead */
      if (position > 0) position = -(this.slider.scrollWidth - this.slider.clientWidth);
      var result = setSlidePosition.call(this, position);
      /* a long jump does not always fire a scroll event, so refresh the current page once it lands */
      var self = this;
      clearTimeout(this.mkUpdateTimeout);
      this.mkUpdateTimeout = setTimeout(function () { self.update(); }, (this.announcerBarAnimationDelay || 0) + 350);
      return result;
    };
  }

  var define = customElements.define.bind(customElements);
  customElements.define = function (name, constructor, options) {
    try {
      if (name === 'slider-component') patchPages(constructor.prototype);
      if (name === 'slideshow-component') patchWrap(constructor.prototype);
    } catch (error) {}
    return define(name, constructor, options);
  };
})();
